import get from 'lodash/get';

import { AbstractSpecification } from './specification';

export class PropertySpecification<T> extends AbstractSpecification<T> {
   constructor(private value: unknown, private property: string) {
      super();
   }

   isSatisfiedBy = (candidate: unknown | undefined): boolean => {
      if (!this.value) return true;
      if (candidate === undefined) return false;
      const objectProperty = get(candidate, this.property);
      if (!objectProperty || typeof objectProperty !== 'string') return false;
      return objectProperty === this.value;
   };
}
